(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-keuzehulp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-keuzehulp')) {
    const VELDEN = ['naam', 'breedte', 'matras', 'dekbed', 'overtrek', 'hoeslaken', 'toelichting'];

    const escapeHtml = (waarde) =>
      String(waarde ?? '').replace(/[&<>"']/g, (t) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[t]);

    const leesJson = (tekst, standaard) => {
      try {
        return JSON.parse(tekst);
      } catch (e) {
        return standaard;
      }
    };

    class TtKeuzehulp extends HTMLElement {
      connectedCallback() {
        this.hulpen = [...this.querySelectorAll('[data-tt-hulp]')];
        const keuzeHouder = this.querySelector('[data-tt-keuzes]');
        keuzeHouder.replaceChildren(
          ...this.hulpen.map((hulp) => {
            const knop = document.createElement('button');
            knop.type = 'button';
            knop.className = 'tt-kh__keuze';
            knop.dataset.ttStart = hulp.dataset.ttHulp;
            knop.setAttribute('aria-pressed', 'false');
            knop.textContent = hulp.dataset.label || hulp.dataset.ttHulp;
            return knop;
          })
        );
        this.keuzes = [...keuzeHouder.querySelectorAll('[data-tt-start]')];
        this.voortgang = this.querySelector('[data-tt-voortgang]');
        this.terug = this.querySelector('[data-tt-terug]');
        this.stap = this.querySelector('[data-tt-stap]');
        this.balk = this.querySelector('[data-tt-balk]');
        this.resultaat = this.querySelector('[data-tt-resultaat]');
        if (!this.hulpen.length) return;

        this.sorteerBedmaten();

        this.keuzes.forEach((knop) => knop.addEventListener('click', () => this.open(knop.dataset.ttStart, true)));
        this.terug.addEventListener('click', () => this.vorige());
        this.addEventListener('click', (event) => {
          const optie = event.target.closest('[data-tt-optie]');
          if (optie && this.contains(optie)) this.kies(optie);
        });

        this.onHash = () => {
          const anker = decodeURIComponent(location.hash.slice(1));
          if (anker && this.hulpVoor(anker) && anker !== this.huidigAnker) {
            this.open(anker, true);
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };
        window.addEventListener('hashchange', this.onHash);

        this.onBlokKies = (event) => this.editorKies(event);
        document.addEventListener('shopify:block:select', this.onBlokKies);

        const startAnker = decodeURIComponent(location.hash.slice(1));
        this.open(this.hulpVoor(startAnker) ? startAnker : this.hulpen[0].dataset.ttHulp, false);
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHash);
        document.removeEventListener('shopify:block:select', this.onBlokKies);
      }

      hulpVoor(anker) {
        return this.hulpen.find((hulp) => hulp.dataset.ttHulp === anker);
      }

      sorteerBedmaten() {
        this.querySelectorAll('[data-tt-bedmaten]').forEach((lijst) => {
          [...lijst.children]
            .sort((a, b) => Number(a.dataset.volgorde || 0) - Number(b.dataset.volgorde || 0))
            .forEach((el) => lijst.appendChild(el));
        });
      }

      open(anker, doorKlant) {
        const hulp = this.hulpVoor(anker);
        if (!hulp) return;
        this.huidigAnker = anker;
        this.hulp = hulp;
        this.vragen = [...hulp.querySelectorAll('[data-tt-vraag]')];
        this.antwoorden = [];
        hulp.querySelectorAll('[data-tt-optie]').forEach((o) => o.setAttribute('aria-pressed', 'false'));

        this.hulpen.forEach((h) => (h.hidden = h !== hulp));
        this.keuzes.forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.ttStart === anker)));

        if (doorKlant && history.replaceState) history.replaceState(null, '', '#' + encodeURIComponent(anker));
        this.toonVraag(0, doorKlant);
      }

      toonVraag(index, focus) {
        this.index = index;
        this.resultaat.hidden = true;
        this.hulp.hidden = false;
        this.vragen.forEach((v, i) => (v.hidden = i !== index));
        const totaal = this.vragen.length;
        this.voortgang.hidden = totaal === 0;
        this.terug.hidden = index === 0;
        this.stap.textContent = totaal > 1 ? `Vraag ${index + 1} van ${totaal}` : '';
        this.balk.style.width = totaal ? `${(index / totaal) * 100}%` : '0';
        if (focus) {
          const kop = this.vragen[index]?.querySelector('.tt-kh__vraagkop');
          kop?.focus({ preventScroll: true });
        }
      }

      vorige() {
        if (!this.resultaat.hidden) {
          this.toonVraag(this.vragen.length - 1, true);
        } else if (this.index > 0) {
          this.toonVraag(this.index - 1, true);
        }
      }

      kies(optie) {
        const vraag = optie.closest('[data-tt-vraag]');
        const index = this.vragen.indexOf(vraag);
        if (index < 0) return;
        vraag.querySelectorAll('[data-tt-optie]').forEach((o) => o.setAttribute('aria-pressed', String(o === optie)));
        this.antwoorden[index] = optie;
        this.antwoorden.length = index + 1;
        if (index < this.vragen.length - 1) {
          this.toonVraag(index + 1, true);
        } else {
          this.toonResultaat();
        }
      }

      context() {
        const ctx = {};
        this.antwoorden.forEach((optie) => {
          if (optie.dataset.bedmaat) Object.assign(ctx, leesJson(optie.dataset.bedmaat, {}));
        });
        return ctx;
      }

      vulIn(html, ctx) {
        let uit = html.replace(/\{(\w+)\}/g, (heel, sleutel) =>
          VELDEN.includes(sleutel) ? escapeHtml(ctx[sleutel] || '') : heel
        );
        // Lege alinea's (bijvoorbeeld een lege toelichting) weghalen.
        return uit.replace(/<p>\s*<\/p>/g, '');
      }

      toonResultaat() {
        const ctx = this.context();
        const koppeling = this.hulp.dataset.koppeling;
        let maat = koppeling && ctx[koppeling] ? ctx[koppeling] : '';
        let geenProducten = false;
        const adviezen = [];
        // Producten van gekozen antwoorden gaan voor; die van een bedmaatvraag zijn de terugval.
        const kaarten = [];
        const terugval = [];
        const gezien = new Set();

        const verzamel = (bron, lijst) => {
          bron.querySelectorAll(':scope > template[data-tt-product]').forEach((tpl) => {
            const sleutel = tpl.dataset.ttProduct;
            if (gezien.has(sleutel)) return;
            gezien.add(sleutel);
            lijst.push(tpl);
          });
        };

        this.antwoorden.forEach((optie, i) => {
          const vraag = this.vragen[i];
          const houder = optie.closest('[data-tt-optie-houder]') || vraag.querySelector('[data-tt-vraag-data]');
          const bron = optie.dataset.bedmaat ? vraag.querySelector('[data-tt-vraag-data]') : houder;
          if (!bron) return;
          const advies = bron.querySelector(':scope > template[data-tt-advies]');
          if (advies) adviezen.push(this.vulIn(advies.innerHTML, ctx));
          if (optie.dataset.maat) maat = optie.dataset.maat;
          if (optie.dataset.geenProducten === 'true') geenProducten = true;
        });

        this.antwoorden.forEach((optie, i) => {
          if (!optie.dataset.bedmaat) {
            const bron = optie.closest('[data-tt-optie-houder]');
            if (bron) verzamel(bron, kaarten);
          }
        });
        if (!kaarten.length) {
          gezien.clear();
          this.antwoorden.forEach((optie, i) => {
            const bron = optie.dataset.bedmaat ? this.vragen[i].querySelector('[data-tt-vraag-data]') : null;
            if (bron) verzamel(bron, terugval);
          });
          kaarten.push(...terugval);
        }

        const slot = this.hulp.querySelector(':scope > template[data-tt-slot]');
        if (slot && slot.innerHTML.trim()) adviezen.push(this.vulIn(slot.innerHTML, ctx));

        const chips = this.antwoorden
          .map((optie, i) => {
            const label = this.vragen[i].dataset.kort || '';
            const naam = optie.querySelector('.tt-kh__optie-naam')?.textContent.trim() || '';
            return `<li><button type="button" class="tt-kh__chip" data-tt-naar="${i}" aria-label="Wijzig: ${escapeHtml(label || naam)}">${
              label ? `<span class="tt-kh__chip-label">${escapeHtml(label)}:</span>` : ''
            }<span>${escapeHtml(naam)}</span></button></li>`;
          })
          .join('');

        const collectieUrl = this.hulp.dataset.collectieUrl;
        const collectieLabel = this.hulp.dataset.collectieLabel;
        const kop = this.dataset.resultaatKop || 'Ons advies';

        this.resultaat.innerHTML = `
          <div class="tt-kh__res">
            <div>
              <h3 class="tt-kh__res-kop">${escapeHtml(kop)}</h3>
              <ul class="tt-kh__antwoorden">${chips}</ul>
              <div class="tt-tekst tt-kh__advies">${adviezen.join('')}</div>
              <div class="tt-kh__acties">
                ${collectieUrl ? `<a class="button-secondary" href="${escapeHtml(collectieUrl)}">${escapeHtml(collectieLabel || 'Bekijk alles')}</a>` : ''}
                <button type="button" class="tt-kh__opnieuw" data-tt-opnieuw>Opnieuw beginnen</button>
              </div>
            </div>
            <div class="tt-kh__producten" data-tt-kaarten></div>
          </div>`;

        const houder = this.resultaat.querySelector('[data-tt-kaarten]');
        if (geenProducten || !kaarten.length) {
          houder.remove();
        } else {
          kaarten.slice(0, 4).forEach((tpl) => houder.appendChild(this.maakKaart(tpl, maat)));
        }

        this.resultaat.querySelectorAll('[data-tt-naar]').forEach((chip) =>
          chip.addEventListener('click', () => this.toonVraag(Number(chip.dataset.ttNaar), true))
        );
        this.resultaat.querySelector('[data-tt-opnieuw]').addEventListener('click', () => this.open(this.huidigAnker, true));

        this.vragen.forEach((v) => (v.hidden = true));
        this.resultaat.hidden = false;
        this.terug.hidden = false;
        this.stap.textContent = 'Klaar';
        this.balk.style.width = '100%';
        this.resultaat.focus({ preventScroll: true });
        const top = this.resultaat.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.6) {
          this.querySelector('.tt-kh__podium').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      maakKaart(tpl, maat) {
        const fragment = tpl.content.cloneNode(true);
        const kaart = fragment.querySelector('.tt-kh-kaart');
        const varianten = leesJson(kaart.dataset.varianten, []);
        const basis = kaart.dataset.url;
        const maatEl = kaart.querySelector('[data-tt-maat]');
        const prijsEl = kaart.querySelector('[data-tt-prijs]');
        const meldingEl = kaart.querySelector('[data-tt-melding]');

        if (maat && varianten.length > 1) {
          const doel = maat.trim().toLowerCase();
          const variant = varianten.find((v) => (v.opties || []).some((o) => String(o).trim().toLowerCase() === doel));
          if (variant) {
            kaart.querySelectorAll('[data-tt-link]').forEach((a) => (a.href = `${basis}?variant=${variant.id}`));
            maatEl.textContent = `Maat ${variant.titel}`;
            maatEl.hidden = false;
            prijsEl.textContent = variant.prijs;
            if (!variant.beschikbaar) {
              meldingEl.textContent = 'Tijdelijk uitverkocht in deze maat';
              meldingEl.hidden = false;
            }
          } else {
            kaart.classList.add('tt-kh-kaart--niet');
            meldingEl.textContent = `Niet in ${maat}`;
            meldingEl.hidden = false;
          }
        }
        return fragment;
      }

      editorKies(event) {
        if (!this.contains(event.target)) return;
        const hulp = event.target.closest('[data-tt-hulp]');
        if (!hulp) return;
        this.open(hulp.dataset.ttHulp, false);
        const vraag = event.target.closest('[data-tt-vraag]');
        if (vraag) this.toonVraag(this.vragen.indexOf(vraag), false);
      }
    }

    customElements.define('tt-keuzehulp', TtKeuzehulp);
  }

  } catch(e) { console.error(e); }
})();
})();
